import React from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";

const BubbleInlineInfo: React.FC<ConversationsBubbleType> = ({ message }) => {
  return <div className="bubble-inlineinfo">{message}</div>;
};

export default BubbleInlineInfo;
